import { cn } from "@/lib/utils";
import { customerInvoiceStatus, type CustomerInvoiceStatus } from "@/lib/invoices/customer-invoice-status";
import type { InvoiceListJoin } from "@/repositories/invoice-records";

const TONES: Record<CustomerInvoiceStatus, string> = {
  Due: "bg-blue-100 text-blue-700",
  Overdue: "bg-red-100 text-red-700",
  Paid: "bg-green-100 text-green-700",
  Void: "bg-gray-100 text-gray-700",
};

export function CustomerInvoiceStatusBadge({ invoice }: { invoice: Pick<InvoiceListJoin, "status" | "due_date"> }) {
  const status = customerInvoiceStatus(invoice.status, invoice.due_date, new Date());
  return <span className={cn("inline-flex items-center px-2 py-1 rounded-sm text-[10px] uppercase select-none", TONES[status])}>{status}</span>;
}
